import type { FilterSelectItem } from '@jane/search/data-access';

export const hasFilterableOptions = (options: FilterSelectItem[]) =>
  !!options.find(({ count }) => count > 0);
